// extracted by mini-css-extract-plugin
export default {"default":"_type_default__d83-g","dense":"_type_dense__rNCNm","card":"_type_card__7R9cf","circle":"_type_circle__R3vB8","action":"_type_action__C77oW","icon":"_type_icon__hNGOK"};